import {Reducer} from "redux";
import { AgentGroup } from "../../shared/model/AgentGroup";
import * as AgentGroupActions from "../actions/FetchAgentGroups";
import {IAction} from "../model/IAction";
import {State} from "../model/State";

export function agentGroups(state: AgentGroup[] = [], action: IAction): AgentGroup[] {
     switch (action.type) {
        case AgentGroupActions.RECIEVE_AGENT_GROUPS:
            const agentGroupAction = action as AgentGroupActions.IReceiveAgentGroupsAction;
            return agentGroupAction.agentGroups;
        default:
            return state;
    }
}
